import { BaseApiModel } from './BaseApiModel';

export class Appraisal extends BaseApiModel {
  public contractId: number;
  public technicianUserId: number;
  public experimentCode: string;
  public type: string;
  public ordinanceApproveNumber: string;
  public experimentDate: Date;
  public validateInitial: Date;
  public equipment: {
    id: number;
    mainSeals: string;
    secondarySeals: string;
    additionalMainSeals: string;
    additionalSecondarySeals: string;
  };
  public spotId: number;
  public laneId: number;
  public manufacturerCompanyId: number;
  public responsibleCompanyId: number;
  public serviceCode: string;
  public value: number;
  public signature: {
    technicianUserId: number;
    representativeUserId: number;
  };
  public AppraisalLane: {
    clientDescription: string;
    code: string;
    direction: string;
    speed: number;
  };
  public AppraisalEquipment: {
    instrument: string;
    manufacturerName: string;
    modelName: string;
    serialNumber: string;
    category: string;
    additionalSerialNumber: string;
  };
  public AppraisalCompanies: Array<{
    type: string;
    name: string;
    cnpj: string;
    street: string;
    number: string;
    zipcode: string;
    neighborhood: string;
    city: string;
    state: string;
  }>;
  public AppraisalUsers: Array<{
    type: string;
    name: string;
  }>;
}
